export const vipMarketingUrl = 'https://tokentax.co/vip';
export const enterpriseMarketingUrl = 'https://tokentax.co/enterprise';

export function getConsultationTypeformUrl(source: string, property: string) {
  return `https://app.tokentax.co/consultation?source=${source}&property=${property}`;
}
